<template>
    <div>
        <div v-for="p in packages">
            <a v-text="p.name" :href="link(p)"></a>
        </div>
    </div>
</template>
<script>
import {PackageNew} from "@models";

export default {
    components: {},
    props: {},
    data() {
        return {
            packages: [],
            user: {},
        }
    },
    watch: {},
    computed: {},
    methods: {
        link(p) {
            return route("mobile.packages.byReference.dashboard", {packageReference: p.referenceNumber})
        }
    },
    async mounted() {
        await User.register()
        this.user = User.user
        this.packages = await PackageNew.all();
    }
}
</script>
